module.exports = __webpack_public_path__ + "f5ae6fcc49387648fe89b3901df96410.png";